<template>
  <div class="error-404">
    <div class="btn">
      <div class="home" @click="$router.push('/')">返回首页</div>
      <!-- <div class="back" @click="$router.back(-1)">上一页</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "",
};
</script>

<style lang="scss" scoped>
.error-404 {
  width: 100%;
  height: 100%;
  background-image: url("~@/assets/image/error/404.png");
  // background-size: 100px 100px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  position: relative;
  .btn {
    width: 300px;
    height: 40px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .home,
  .back {
    width: 100px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid #ffffff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background: #fc3e39;
    }
  }
}
</style>
